if (!customElements.get('takoo-media-b1')) {
  customElements.define('takoo-media-b1', class extends HTMLElement {
    connectedCallback() {
      if (this.cleanup) return;
      const track = this.querySelector('.takoo-media-b1__track');
      const thumbs = Array.from(this.querySelectorAll('[data-photo]'));
      const buttons = Array.from(this.querySelectorAll('[data-direction]'));
      const counter = this.querySelector('[data-counter]');
      const controls = this.querySelector('.takoo-media-b1__controls');
      if (!track || !thumbs.length || !counter || !controls) return;
      let index = 0;
      let frame = 0;
      const update = () => {
        frame = 0;
        index = Math.max(0, Math.min(thumbs.length - 1, Math.round(track.scrollLeft / Math.max(1, track.clientWidth))));
        this.querySelectorAll('video').forEach(video => { if (video.closest('.takoo-media-b1__slide') !== track.children[index]) video.pause(); });
        counter.textContent = `${index + 1} / ${thumbs.length}`;
        thumbs.forEach((thumb, i) => {
          if (i === index) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        buttons.forEach(button => { button.disabled = Number(button.dataset.direction) < 0 ? index === 0 : index === thumbs.length - 1; });
        const active = thumbs[index];
        const strip = active.parentElement;
        const activeBox = active.getBoundingClientRect();
        const stripBox = strip.getBoundingClientRect();
        if (activeBox.left < stripBox.left || activeBox.right > stripBox.right) {
          strip.scrollTo({left: strip.scrollLeft + activeBox.left - stripBox.left - strip.clientWidth / 2 + activeBox.width / 2, behavior: 'instant'});
        }
      };
      const go = next => {
        const target = Math.max(0, Math.min(thumbs.length - 1, next));
        track.scrollTo({left: target * track.clientWidth, behavior: 'instant'});
        update();
      };
      const click = event => {
        const thumb = event.target.closest('[data-photo]');
        const button = event.target.closest('[data-direction]');
        if (thumb && this.contains(thumb)) { event.preventDefault(); go(Number(thumb.dataset.photo)); }
        else if (button && this.contains(button)) go(index + Number(button.dataset.direction));
      };
      const key = event => {
        if (event.target !== track) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
          event.preventDefault(); go(index + (event.key === 'ArrowRight' ? 1 : -1));
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault(); go(event.key === 'Home' ? 0 : thumbs.length - 1);
        }
      };
      const scroll = () => { if (!frame) frame = requestAnimationFrame(update); };
      const resize = new ResizeObserver(() => go(index));
      this.addEventListener('click', click);
      track.addEventListener('keydown', key);
      track.addEventListener('scroll', scroll, {passive: true});
      resize.observe(track);
      controls.hidden = false;
      update();
      this.cleanup = () => {
        this.removeEventListener('click', click);
        track.removeEventListener('keydown', key);
        track.removeEventListener('scroll', scroll);
        resize.disconnect();
        cancelAnimationFrame(frame);
        this.cleanup = null;
      };
    }
    disconnectedCallback() { this.cleanup?.(); }
  });
}

